import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteConfirm = ({ show, onHide, onConfirm, producto, loading }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-exclamation-triangle text-danger me-2"></i>
          Confirmar Eliminación
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <p className="mb-2">
          ¿Estás seguro de que deseas eliminar este producto?
        </p>
        {producto && (
          <div className="alert alert-warning mb-0">
            <strong>{producto.nombre}</strong>
            <br />
            <small className="text-muted">Esta acción no se puede deshacer.</small>
          </div>
        )}
      </Modal.Body>
      
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>
              Eliminando...
            </>
          ) : (
            <>
              <i className="fas fa-trash me-2"></i>
              Eliminar
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirm;
